import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar, Divider } from 'antd';

import { showAtDev } from '@/env';
import {
    AppstoreAddOutlined,
    ControlTwoTone,
    IdcardTwoTone,
    MessageTwoTone,
    PushpinTwoTone,
    QuestionCircleTwoTone,
    FileTextTwoTone,
} from '@/icons';
import { useTopNavAuthService } from '../menuService';
import DocsLink from '../DocsLink';

import styles from './AppLayoutHeaderMenu.module.less';

const AppLayoutHeaderMenu = () => {
    const { customerEntry, conversationEntry, adminEntry, shareEntry } = useTopNavAuthService();

    return (
        <>
            <>
                <div className={styles.action}>
                    <Link to="/">
                        <Avatar icon={<PushpinTwoTone />} style={{ marginRight: 10 }} />
                        应用管理
                    </Link>
                </div>
                <div className={styles.dividerBlock}>
                    <Divider type="vertical" className={styles.divider} />
                </div>
            </>
            {customerEntry && (
                <>
                    <div className={styles.action}>
                        <Link to="/customer">
                            <Avatar icon={<IdcardTwoTone />} style={{ marginRight: 10 }} />
                            客户管理
                        </Link>
                    </div>
                    <div className={styles.dividerBlock}>
                        <Divider type="vertical" className={styles.divider} />
                    </div>
                </>
            )}

            {conversationEntry && (
                <>
                    <div className={styles.action}>
                        <Link to="/conversation">
                            <Avatar icon={<MessageTwoTone />} style={{ marginRight: 10 }} />
                            会话管理
                        </Link>
                    </div>
                    <div className={styles.dividerBlock}>
                        <Divider type="vertical" className={styles.divider} />
                    </div>
                </>
            )}

            {adminEntry && (
                <>
                    <div className={styles.action}>
                        <Link to="/admin">
                            <Avatar icon={<ControlTwoTone />} style={{ marginRight: 10 }} />
                            系统管理
                        </Link>
                    </div>
                    <div className={styles.dividerBlock}>
                        <Divider type="vertical" className={styles.divider} />
                    </div>
                </>
            )}
            {
                shareEntry && (
                    <>
                        <div className={styles.action}>
                            <Link to="/wechat">
                                <Avatar icon={<FileTextTwoTone />} style={{ marginRight: 10 }} />
                                艾智享
                            </Link>
                        </div>
                        <div className={styles.dividerBlock}>
                            <Divider type="vertical" className={styles.divider} />
                        </div>
                    </>
                )
            }

            {/* <div className={styles.action}>
                <DocsLink
                    icon={<Avatar icon={<QuestionCircleTwoTone />} style={{ marginRight: 10 }} />}
                />
            </div>
            <div className={styles.dividerBlock}>
                <Divider type="vertical" className={styles.divider} />
            </div> */}
            {/* 
            {showAtDev && (
                <>
                    <div className={styles.action}>
                        <Link to="/dev/icons">
                            <Avatar icon={<AppstoreAddOutlined />} style={{ marginRight: 10 }} />
                            Icons
                        </Link>
                    </div>
                    <Divider type="vertical" className={styles.divider} />
                </>
            )} */}
        </>
    );
};

export default AppLayoutHeaderMenu;
